export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fecae8c7d3d4c379db789beab4813002b4c4db162&name=fetchTypeahead!'